// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import { SvgIcon } from '../'

export const LoadingAmount = () => (
  <SvgIcon
    variant='utility'
    symbol='threedots'
    size='small'
    className='slds-p-left_small'
  />
)



// WEBPACK FOOTER //
// ./src/components/creditapplication-income/LoadingAmount.js